module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vskel11-0c85bf4ff70d121d557dfe49901d2bba.jpg";